import { OnboardingState } from '@developerz/domain';
import { IconArrowRight, IconCheck } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { ONBOARDING_STEPS } from '../lib/onboardingSteps';
import { orgHref } from '../lib/org';
import { buttonClass } from './ui/Button';

// The terminal hand-off card. Presenter — lifted out of the route so both it
// and the route stay under the 150-LOC cap, and so `active`'s entry in
// `ONBOARDING_STEPS` has a consumer like every other state's.
export type OnboardingDoneCardProps = {
  readonly ghAppInstallUrl: string;
};

export function OnboardingDoneCard(props: OnboardingDoneCardProps): JSX.Element {
  const spec = ONBOARDING_STEPS[OnboardingState.Active];
  return (
    <div class="card card--footered" role="status">
      <div class="card__header">
        <span class="onboarding__done-mark" aria-hidden="true">
          <IconCheck size="1.5rem" />
        </span>
        <h2 class="card__title">{t(spec.titleKey)}</h2>
        <p class="card__desc">{t(spec.bodyKey)}</p>
      </div>
      <div class="card__footer">
        {/* Active is terminal, but every install CTA in the app (sidebar, repos
            empty state) routes here — a finished account arriving wants to add
            repos, so hand it the GitHub App install page instead of a dead end
            (#323). A new tab is right HERE and wrong on the funnel's own install
            step: this screen is not waiting on the redirect back. */}
        <a
          class={buttonClass({ variant: 'outline', size: 'sm' })}
          href={props.ghAppInstallUrl}
          target="_blank"
          rel="noreferrer"
        >
          {t('onboarding.done_install')}
        </a>
        {/* Terminal handoff out of the funnel — a full nav to `/` gives the
            dashboard a fresh load, no stale onboarding state. */}
        <a class={buttonClass({ size: 'sm' })} href={orgHref('/')}>
          {t(spec.actionKey)}
          <IconArrowRight size="0.875rem" />
        </a>
      </div>
    </div>
  );
}
